(() => {
  const registryKey = Symbol.for('teylens.design.prefill');
  if (window[registryKey]) return;
  const state = { initialized: new WeakSet(), counter: 0 };
  window[registryKey] = state;
  const safeValue = value => {
    if (typeof value !== 'string' || value.length > 64) return '';
    const clean = value.trim().replace(/ +/g, ' ');
    return /^[\p{L}\p{N}][\p{L}\p{N} .&'’()\-]{0,63}$/u.test(clean) ? clean : '';
  };
  const initialize = root => {
    const parameters = new URLSearchParams(window.location.search);
    const rawStart = parameters.get('start');
    const start = ['style', 'shape', 'quiz'].includes(rawStart) ? rawStart : '';
    const style = safeValue(parameters.get('setting_style'));
    const shape = safeValue(parameters.get('diamond_shape'));
    if (!start && !style && !shape) return;
    const fields = [...root.querySelectorAll('textarea[data-teylens-design-note][name="contact[body]"]')];
    if (root.matches?.('textarea[data-teylens-design-note][name="contact[body]"]')) fields.unshift(root);
    fields.forEach(field => {
      if (state.initialized.has(field) || field.disabled || field.readOnly) return;
      const template = field.dataset.designNoteTemplate;
      if (!template || template.length > 1500) return;
      const startLabels = { style: field.dataset.designStartStyle, shape: field.dataset.designStartShape, quiz: field.dataset.designStartQuiz };
      const values = { start: start ? startLabels[start] || '' : '', style, shape };
      const note = template.split(/\r?\n/).filter(line => {
        const tokens = [...line.matchAll(/\{(start|style|shape)\}/g)].map(match => match[1]);
        return !tokens.some(token => !values[token]);
      }).map(line => line.replace(/\{(start|style|shape)\}/g, (_, token) => values[token])).join('\n').trim();
      if (!note) return;
      const original = field.value;
      if (!original.includes(note)) {
        const separator = original ? /\n\s*\n$/.test(original) ? '' : '\n\n' : '';
        const candidate = `${original}${separator}${note}${original ? '' : '\n\n'}`;
        if (field.maxLength > 0 && candidate.length > field.maxLength) return;
        field.value = candidate;
      }
      state.initialized.add(field);
      const summary = document.createElement('p');
      summary.className = 'ty-form-note ty-design-note-summary';
      summary.id = `${field.id || `teylens-message-${++state.counter}`}-design-note`;
      summary.dataset.teylensDesignSummary = '';
      summary.style.whiteSpace = 'pre-line';
      summary.textContent = note;
      field.before(summary);
      const descriptionIds = new Set((field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      descriptionIds.add(summary.id);
      field.setAttribute('aria-describedby', [...descriptionIds].join(' '));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.addEventListener('pageshow', () => initialize(document));
})();
